import { ResponsiveValue } from 'styled-system';
import { convertToTileWidth } from './ProductGridUtils';

export const DEFAULT_TILES_PER_ROW: ResponsiveValue<number> = [2, 2, 4, 4, 4, 5];
export const DEFAULT_TILE_WIDTH: ResponsiveValue<number> = convertToTileWidth(DEFAULT_TILES_PER_ROW);
export const GRID_WIDTH_WITH_SIDEBAR = 'calc(1888px - 300px)';
export const GRID_WIDTH_WITH_OUT_SIDEBAR = '100vw';
export const GRID_WIDTHS = [
  GRID_WIDTH_WITH_OUT_SIDEBAR,
  GRID_WIDTH_WITH_OUT_SIDEBAR,
  GRID_WIDTH_WITH_OUT_SIDEBAR,
  GRID_WIDTH_WITH_OUT_SIDEBAR,
  GRID_WIDTH_WITH_SIDEBAR,
];
